import { useAuthUiStore } from '@/features/auth/store'
import { RequestPasswordResetModal } from './RequestPasswordResetModal'

export function RequestPasswordResetModalSlot() {
  const modalIsOpen = useAuthUiStore(s => s.isRequestPasswordResetModalOpen)

  return modalIsOpen ? <RequestPasswordResetModal /> : null
}
